export default __webpack_public_path__ + "static/media/news7.7397bd49.PNG";